import { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import HiddenInput from '@components/form/context/HiddenInput'
import Input from '@components/form/context/Input'
import Error from '@components/form/validation/Error'
import Checkbox from '@components/form/context/Checkbox'
import MessageHelper from '@utils/messageHelper'
import useT from '@hooks/useTranslation'
import { post } from '@api/apiFetcher'
import nipRegexp from '@utils/regexp/instances/nip'

import styles from 'styles/add/HotUserRegistrationInput.module.css'

const INPUTS = {
    name: { t: 'Imię', name: 'name', validations: { required: 'Pole Imię jest wymagane' }},
    email: { t: 'Email', name: 'email', validations: { required: 'Pole Email jest wymagane' }},
    phone: { t: 'Telefon', name: 'phone', validations: { required: 'Pole Telefon jest wymagane' }},
    pass: { t: 'Hasło', name: 'password', type: 'password', validations: { required: 'Pole hasło jest wymagane' }},
    confirm_pass: { t: 'Powtórz hasło', name: 'confirm_password', type: 'password', validations: { required: 'Potwierdzenie hasła jest wymagane' }},

    firm_account: { t: 'Konto firmowe', name: 'dealer-account' },
    rodo: { t: 'Oświadczam, że zapoznałem się i akceptuję treść Regulaminu i Polityki Prywatności',
        name: 'rodo', type: 'checkbox', validations: { required: 'Znajomość regulaminu i polityki prywatności jest wymagana' }},
}

export default function HotUserRegistrationInput () {
    const { watch } = useFormContext()
    const showNIP = watch('dealer-account')

    return <div className={styles.wrapper}>
        <h2>{useT('Aby ogłoszenie było aktywne musisz założyć konto')}</h2>
        <HiddenInput name="loginless-registration" defaultValue={true} />
        <Input {...INPUTS.name} required error />
        <Input {...INPUTS.email} required error />
        <Input {...INPUTS.phone} required error />
        <Input {...INPUTS.pass} required error />
        <Input {...INPUTS.confirm_pass} required error />
        <br/><br/><Checkbox {...INPUTS.rodo} required /><Error name="rodo" />
        <br/><br/><Checkbox {...INPUTS.firm_account} /><br/><br/>
        { showNIP && <NIP /> }
    </div>
}

function NIP () {
    const { unregister, setValue } = useFormContext()
    const [values, setValues] = useState([])

    const nip = { t: 'NIP', name: 'nip', type: 'number', onInput: (e) => {
        const { target: { value }} = e
        const nip = value.slice(0, 10)

        if (value.length > 10) {
            setValue('nip', nip)
        }

        const isValid = nipRegexp.test(nip)
        if (isValid) {
            post({ path: '/api/gus', data: { nip }})
                .then(res => {
                    MessageHelper.summary(res)
                    if (!res.success) {
                        setValue('ok', false)
                        setValues([])
                        return
                    }

                    const { firm_name, firm_country, firm_phone, firm_address } = res.report // email
                    if (firm_name) setValue('firm_name', firm_name)
                    if (firm_country) setValue('firm_country', firm_country)
                    if (firm_phone) setValue('firm_phone', firm_phone)
                    if (firm_address) setValue('firm_address', firm_address)

                    setValues([firm_name, firm_country, firm_phone, firm_address])
                    setValue('ok', true)
                    setValue('nip', nip)
                })
                .catch(err => {
                    setValue('ok', false)
                    setValues([])
                })
        }
    }, validations: { required: 'Prawidłowy NIP jest wymagany' }}

    useEffect(() => {
        return () => {
            unregister('ok')
            unregister('firm_name')
            unregister('firm_country')
            unregister('firm_phone')
            unregister('firm_address')
            unregister('nip')
        }
    }, [])

    console.log(values)

    return <>
        <HiddenInput name="ok" defaultValue="" required={false} />
        <HiddenInput name="firm_name" defaultValue="" required={false} />
        <HiddenInput name="firm_country" defaultValue="" required={false} />
        <HiddenInput name="firm_phone" defaultValue="" required={false} />
        <HiddenInput name="firm_address" defaultValue="" required={false} />
        <Input {...nip} required error /><br/>
        <View values={values} text={['Nazwa firmy','Kraj','Telefon','Adres']} />
    </>
}

function View ({ values }) { // text
    return values.map((val, i) => {
        return val
            ? <p><b>{val}</b></p>
            : null
    })
}